import { useQuery } from 'react-query';

import {
  NAV_CURRENT_USER_KEY,
  NavCurrentUserResponse,
  getNavCurrentUser,
} from '../utils/backend-api/currentUser';

export default function useNavCurrentUser() {
  const { data, isLoading } = useQuery<NavCurrentUserResponse>(
    NAV_CURRENT_USER_KEY,
    () => getNavCurrentUser(),
    {}
  );
  return { navProps: data?.navProps, isNavCurrentUserLoading: isLoading };
}
